import React, { useEffect } from "react";
import BusinessHeroSection from "../../Components/Business/BusinessHeroSection";
import BusinessBodySection from "../../Components/Business/BusinessBodySection";
import styled, { keyframes } from "styled-components";
import ScheduleDemo from "../../Components/Business/ScheduleDemo";
import useSWR from "swr";
import { getButtonByPartner } from "../../api/axios";
import { useTheme } from "@mui/material/styles";

export default function BusinessComponent() {
  const theme = useTheme();
  const BusinessHeader = styled.h1`
  margin: 0;
  padding: 30px 0px 50px;
  text-align: left;
  font-size: 50px;
  line-height: 1.2;
  color: ${theme.palette.primary.main};
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  opacity: 0;
  animation: ${animation} 1s 0s forwards;

  span {
    color: ${theme.palette.text.main};
  }
  
  @media (max-width: 1100px) {
    font-size: 45px;
  }
  @media (max-width: 975px) {
    font-size: 40px;
    line-height: 1.1;
  }
  @media (max-width: 900px) {
    font-size: 38px;
    text-align: center;
  }
  @media (max-width: 895px) {
    font-size: 36px;
  }
  @media (max-width: 855px) {
    font-size: 35px;
  }
  @media (max-width: 715px) {
    font-size: 30px;
    line-height: 1.2;
    padding: 50px 20px 40px;
  }
  @media (max-width: 480px) {
    font-size: 26px;
    line-height: 1.3;
    padding: 40px 15px 30px;
  }
  @media (max-width: 425px) {
    font-size: 24px;
    padding: 20px 10px 20px;
  }
`;


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { data: buttons = [] } = useSWR(
    `getForBusinessgetButton`,
    async () => {
      try {
        const { data } = await getButtonByPartner();
        return data?.data;
      } catch (error) {
        console.error("error: ", error);
      }
    },
    {
      revalidateOnFocus: false,
    }
  );

  return (
    <BusinessComponentWrapper>
      <BusinessHeader>
        For{" "}
        <span>
          <b>Businesses</b>
        </span>
      </BusinessHeader>
      <BusinessHeroSection buttons={buttons} />
      <BusinessBodySection />
      <ScheduleDemo buttons={buttons} />
    </BusinessComponentWrapper>
  );
}

const animation = keyframes`
   from { opacity: 0; filter: blur(10px); }
  to { opacity: 1; filter: blur(0px);}
`;
export const BusinessComponentWrapper = styled.div`
  max-width: 1536px;
  margin: 0 auto;
  padding: 0 20px;
  
  @media (max-width: 768px) {
    padding: 0 15px;
  }
  
  @media (max-width: 480px) {
    padding: 0 10px;
  }
`; 